import { AuthService } from '@auth0/auth0-angular';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, map } from 'rxjs';

import { UserPermissionResponseModel } from '../../models/responses/user-permission-response.model';
import { CookiesService } from './cookies.service';
import { ApiService } from '../../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(
    private cookiesService: CookiesService,
    private auth0: AuthService,
    private api: ApiService,
    private router: Router,
  ) { }

  /**
  * @deprecated Este método será removido em versões futuras - Utilize o PermissionBaseComponent (IsInterno)
  */
  isEmailDomainRmFarma(): Observable<boolean> {
    return this.auth0.user$.pipe(
      map((response) => {
        const email = response?.email;
        const dominio = this.extrairDominioDoEmail(email);
        return dominio?.includes('hipersaude') ?? false;
      })
    );
  }

  /**
  * @deprecated Este método será removido em versões futuras após testes
  */
  isEmailForTest(): Observable<boolean> {
    const users: string[] = [
      "patricia.silva@rmfarma.com.br",
      "patricia.silva@hipersaude.com.br",
      "walisson.ferreira@rmfarma.com.br",
      "walisson.ferreira@hipersaude.com.br",
      "fabio.cassimiro@rmfarma.com.br",
      "fabio.cassimiro@rmfarma.com.br",
      "yuri.santana@rmfarma.com.br",
      "andre.monteiro@rmfarma.com.br",
      "fabiocassimiro.project@gmail.com",
      "ygor.marques@rmfarma.com.br",
      "carlos.junior@rmfarma.com.br",
      "gisselle.bequis@rmfarma.com.br"
    ]

    return this.auth0.user$.pipe(
      map((response) => {
        const email = response?.email ?? ''
        return users.includes(email);
      })
    );
  }

  extrairDominioDoEmail(email: string | undefined) {
    if (typeof email === 'string' && email.length > 0) {
      const partes = email.split('@');
      if (partes.length === 2 && partes[1]) {
        return partes[1];
      } else {
        console.log('Email inválido:', email);
        return null;
      }
    } else {
      console.log('Entrada não é um email:', email);
      return null;
    }
  }

  checkAuthenticationStatus(): boolean {
    return !!this.cookiesService.getItem('TOKEN');
  }

  redirectToLogin(): void {
    this.router.navigate(['/']);
  }

  getUserPermission(): Observable<UserPermissionResponseModel> {
    return this.api.getUserPermission();
  }
}
